import { render, staticRenderFns } from "./GeneralResult.vue?vue&type=template&id=bee61b48&scoped=true&lang=pug&"
import script from "./GeneralResult.vue?vue&type=script&lang=ts&"
export * from "./GeneralResult.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee61b48",
  null
  
)

export default component.exports